import { DELETE_DATA_MENU_ROLES, GET_DATA_MENU_ALL, GET_DATA_MENU_ALL_SUCCEEDED, GET_DATA_MENU_ROLES, GET_DATA_MENU_ROLES_SUCCEEDED, GET_DATA_ROLES_ALL, GET_DATA_ROLES_ALL_SUCCEEDED, ISRESULT, REQUERT_MENU_ALL_FAILED, REQUERT_MENU_ROLES_FAILED, REQUERT_ROLES_ALL_FAILED, SET_DATA_MENU, SET_DATA_MENU_ROLES } from "./actionTypes"


export const IsResultAction = (isResult) => {
    return {
        type: ISRESULT,
        isResult: isResult
    }
}

// Menu
export const GetDataMenuAllAction = () => {
    return {
        type: GET_DATA_MENU_ALL
    }
}

export const GetDataMenuAllSuccessAction = (DataMenu) => {
    return {
        type: GET_DATA_MENU_ALL_SUCCEEDED,
        DataMenu: DataMenu
    }
}

export const RequertMenuAllFailedAction = (Err) =>{
    return {
        type: REQUERT_MENU_ALL_FAILED,
        err: Err
    }
}

export const SetDataMenuAction = (DataMenu) =>{
    return {
        type: SET_DATA_MENU,
        DataMenu: DataMenu
    }
}

 //Roles
 export const GetDataRolesAllAction = () => {
    return {
        type: GET_DATA_ROLES_ALL
    }
}

export const GetDataRolesAllSuccessAction = (DataRoles) => {
    return {
        type: GET_DATA_ROLES_ALL_SUCCEEDED,
        DataRoles: DataRoles
    }
}

export const RequertRolesAllFailedAction = (Err) =>{
    return {
        type: REQUERT_ROLES_ALL_FAILED,
        err: Err
    }
}


 //MenuRoles
 export const GetDataMenuRolesAction = () => {
    return {
        type: GET_DATA_MENU_ROLES
    }
}

export const GetDataMenuRolesSuccessAction = (DataMenuRoles) => {
    return {
        type: GET_DATA_MENU_ROLES_SUCCEEDED,
        DataMenuRoles: DataMenuRoles
    }
}

export const RequertMenuRolesFailedAction = (Err) =>{
    return {
        type: REQUERT_MENU_ROLES_FAILED,
        err: Err
    }
}
 export const SetDataMenuRolesAction = (DataMenuRoles) =>{
     return {
        type: SET_DATA_MENU_ROLES,
        DataMenuRoles: DataMenuRoles
     }
 }
 export const DeleteDataMenuRolesAction = (DataDelete) =>{
     return {
         type : DELETE_DATA_MENU_ROLES,
         DataDelete: DataDelete
     }
 }